module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-tabs', {
    staticClass: "gPageBorder",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    staticClass: "gForm",
    attrs: {
      "label": 'LOGO' + _vm.$t('app_setting'),
      "name": "second"
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "LOGO",
      "prop": "pass"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "on-success": _vm.handleBgAvatarSuccess,
      "before-upload": _vm.beforeBgAvatarUpload
    }
  }, [(_vm.logo) ? _c('div', {
    staticStyle: {
      "background": "#58B7FF"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "96px",
      "margin-top": "16px",
      "padding": "0 16px 0 16px",
      "background": "none"
    },
    attrs: {
      "src": _vm.logo
    }
  })]) : _c('div', {
    staticStyle: {
      "width": "400px",
      "height": "80px",
      "line-height": "80px",
      "font-size": "20px",
      "color": "#99A9BF"
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#99A9BF"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickPicToUlPic')) + "，200k " + _vm._s(_vm.$t('app_within')) + _vm._s(_vm.$t('app_pgsFormat')) + "，" + _vm._s(_vm.$t('app_sgUseAndAdUse')))])], 1), _vm._v(" "), _c('el-form-item', [(_vm.logoValue) ? _c('span', [_c('el-button', {
    on: {
      "click": _vm.cancelLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sureChange')))])], 1) : _c('span', [_c('el-button', {
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.cancelLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": "",
      "type": "primary"
    },
    on: {
      "click": _vm.saveLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sureChange')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.defaultLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dfIcon')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName === 'first'),
      expression: "activeName === 'first'"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tuisongjl')))]), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('lin_global.tuisonglx')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.pushType(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "successNum",
      "label": _vm.$t('lin_global.chenggong')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "failNum",
      "label": _vm.$t('lin_global.shibai')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opeTime",
      "label": _vm.$t('lin_global.tuisongtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [(scope.row.submit) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitRow(scope.row.type, scope.row.config, scope.row.mechId, scope.row.terminalNo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-rotate-right",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f747081"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/sysSetting.vue
// module id = 968
// module chunks = 0